// P&L rebuild, step 2: pure helpers for copying the old P&L entries (collection crmPnl)
// into the new storage (collection crmPnlEntries). No imports here, so it can be tested alone.
// The old entries are never changed. A copy gets the id "m_" + old id, so copying twice
// can never make duplicates.

export const NEW_ID_PREFIX = "m_";

const r2 = (n) => Math.round((Number(n) || 0) * 100) / 100;

// One old entry -> one new entry. Income and Expense go to the common project;
// Owner's money (Transfer) has no project.
export function mapOldEntry(e, user, commonName) {
  const isTransfer = e.type === "Transfer";
  const out = {
    date: e.date,
    description: e.description || "",
    type: e.type,
    category: e.category || "",
    party: e.party || "",
    paymentMode: e.paymentMode || "",
    direction: e.direction || "",
    amount: Number(e.amount) || 0,
    gstRate: Number(e.gstRate) || 0,
    gstAmount: Number(e.gstAmount) || 0,
    tdsAmount: 0,
    project: isTransfer ? "" : commonName,
    source: "migrated",
    oldId: e.id,
    createdByUid: e.createdByUid || "",
    createdByName: e.createdByName || "",
    migratedByUid: user.uid,
  };
  if (e.reversalOf) out.reversalOf = NEW_ID_PREFIX + e.reversalOf;
  if (e.createdAt) out.createdAt = e.createdAt;
  return out;
}

// Old entries that have no copy yet.
export function missingOld(oldList, newList) {
  const done = new Set();
  (newList || []).forEach((n) => { if (n.source === "migrated" && n.oldId) done.add(n.oldId); });
  return (oldList || []).filter((o) => !done.has(o.id));
}

// Count, amount (without GST) and GST for each type. Used for the "old = copied" check.
export function summarize(entries) {
  const out = { Income: { count: 0, amount: 0, gst: 0 }, Expense: { count: 0, amount: 0, gst: 0 }, Transfer: { count: 0, amount: 0, gst: 0 } };
  (entries || []).forEach((e) => {
    const t = out[e.type];
    if (!t) return;
    t.count += 1;
    t.amount = r2(t.amount + (Number(e.amount) || 0));
    t.gst = r2(t.gst + (Number(e.gstAmount) || 0));
  });
  return out;
}

export function sameSummary(a, b) {
  return ["Income", "Expense", "Transfer"].every(
    (k) => a[k].count === b[k].count && a[k].amount === b[k].amount && a[k].gst === b[k].gst
  );
}
